// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 37.4rem) {
  .style_hide-sm__T4msx {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__M9pJ1 {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__gTKV0 {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__XFGaJ {
    display: none !important;
  }
}
/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
h1 {
  font-size: 1.625rem;
  font-weight: 400;
}
@media (max-width: 37.4rem) {
  h1 {
    font-size: 1.4375rem;
  }
}
h2 {
  font-size: 1.25rem;
  font-weight: 400;
}
@media (max-width: 37.4rem) {
  h2 {
    font-size: 1.0625rem;
  }
}
h3 {
  font-size: 1.125rem;
  font-weight: 400;
}
@media (max-width: 37.4rem) {
  h3 {
    font-size: 1.0625rem;
  }
}
h4 {
  font-size: 1rem;
  font-weight: 500;
  margin: 1rem 0 0.5rem 0;
}
h5 {
  font-size: 0.8125rem;
  font-weight: 400;
}
hr {
  display: block;
  height: 0.0625rem;
  border: 0;
  border-top: solid 0.0625rem var(--colorBorderTertiary);
  margin: 1em 0;
  padding: 0;
}
a {
  color: var(--colorTextLinkDefault);
}
a:hover {
  color: var(--colorTextLinkPressed);
}
p {
  margin: 1rem 0;
  color: var(--colorTextPrimary);
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px var(--colorBackgroundPrimaryDefault) inset !important;
}
input::-ms-clear {
  width: 0;
  height: 0;
}
small {
  font-size: 0.875rem;
  line-height: 1.1875rem;
}
.style_secondary__PT3iD {
  color: var(--colorTextSecondary);
}
.style_section__R4rkM {
  flex-grow: 1;
}
.style_sectionHeader__pz9Vj {
  padding: 0 1rem;
  margin: 0.5rem 0;
}
.style_sectionBody__MzPan {
  padding: 0 1rem;
  color: var(--colorTextMuted);
  font-size: 0.875rem;
}
.style_sectionBody__MzPan p {
  color: var(--colorTextPrimary);
}
.style_sectionNoHeader__s2duM {
  margin: 0.5rem 0;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./app/resources/styles/media.less","webpack://./app/components/Section/style.less","webpack://./app/resources/styles/text.less"],"names":[],"mappings":"AAMA;EACE;IACE,wBAAA;ECLF;AACF;ADQA;EACE;IACE,wBAAA;ECNF;AACF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;AACA;;;;;;;;;;;;EAYE;AC5BF;EACI,mBAAA;EACA,gBAAA;AD8BJ;AC7BI;EAAA;IACI,oBAAA;EDgCN;AACF;AC7BA;EACI,kBAAA;EACA,gBAAA;AD+BJ;AC9BI;EAAA;IACI,oBAAA;EDiCN;AACF;AC9BA;EACI,mBAAA;EACA,gBAAA;ADgCJ;AC/BI;EAAA;IACI,oBAAA;EDkCN;AACF;AC/BA;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;ADiCJ;AC9BA;EACI,oBAAA;EACA,gBAAA;ADgCJ;AC7BA;EACI,cAAA;EACA,iBAAA;EACA,SAAA;EACA,sDAAA;EACA,aAAA;EACA,UAAA;AD+BJ;AC5BA;EACI,kCAAA;AD8BJ;AC3BA;EACI,kCAAA;AD6BJ;AC1BA;EACI,cAAA;EAEA,8BAAA;AD2BJ;ACvBA;EACI,sFAAA;ADyBJ;ACrBA;EACI,QAAA;EACA,SAAA;ADuBJ;ACpBA;EACI,mBAAA;EACA,sBAAA;ADsBJ;ACnBA;EACI,gCAAA;ADqBJ;AAjGA;EACE,YAAA;AAmGF;AAhGA;EACE,eAAA;EACA,gBAAA;AAkGF;AA/FA;EACE,eAAA;EACA,4BAAA;EACA,mBAAA;AAiGF;AApGA;EAMI,8BAAA;AAiGJ;AA7FA;EACE,gBAAA;EACA,WAAA;AA+FF","sourcesContent":["//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}","@import \"../../resources/styles/media\";\n@import \"../../resources/styles/text\";\n\n.section {\n  flex-grow: 1;\n}\n\n.sectionHeader {\n  padding: 0 1rem;\n  margin: 0.5rem 0;\n}\n\n.sectionBody {\n  padding: 0 1rem;\n  color: @ternaryText;\n  font-size: 14/16rem;\n\n  p {\n    color: @primaryText;\n  }\n}\n\n.sectionNoHeader {\n  margin: 0.5rem 0;\n  width: 100%; // ie11 needs this\n}\n","@import \"./colors\";\n@import \"./variables\";\n@import \"./media\";\n\nh1 {\n    font-size: 1.625rem; //26px\n    font-weight: @normal;\n    @media (max-width: @screen-sm) {\n        font-size: 1.4375rem;\n    }\n}\n\nh2 {\n    font-size: 1.25rem; //20px\n    font-weight: @normal;\n    @media (max-width: @screen-sm) {\n        font-size: 1.0625rem;\n    }\n}\n\nh3 {\n    font-size: 1.125rem; //18px\n    font-weight: @normal;\n    @media (max-width: @screen-sm) {\n        font-size: 1.0625rem;\n    }\n}\n\nh4 {\n    font-size: 1rem; //16px\n    font-weight: @semibold;\n    margin: 1rem 0 0.5rem 0;\n}\n\nh5 {\n    font-size: 0.8125rem; //12px\n    font-weight: @normal;\n}\n\nhr {\n    display: block;\n    height: 0.0625rem;\n    border: 0;\n    border-top: solid 0.0625rem var(--colorBorderTertiary);\n    margin: 1em 0;\n    padding: 0;\n}\n\na {\n    color: var(--colorTextLinkDefault);\n}\n\na:hover {\n    color: var(--colorTextLinkPressed);\n}\n\np {\n    margin: 1rem 0;\n    //font-size: 14/16rem;\n    color: var(--colorTextPrimary);\n}\n\n// https://stackoverflow.com/questions/2920306/google-chrome-form-autofill-and-its-yellow-background\ninput:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0 1000px var(--colorBackgroundPrimaryDefault) inset !important;\n}\n\n// https://stackoverflow.com/questions/14007655/remove-ie10s-clear-field-x-button-on-certain-inputs\ninput::-ms-clear {\n    width: 0;\n    height: 0;\n}\n\nsmall {\n    font-size: 14/16rem;\n    line-height: 19/16rem;\n}\n\n.secondary {\n    color: var(--colorTextSecondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__T4msx`,
	"hideSm": `style_hide-sm__T4msx`,
	"visible-sm": `style_visible-sm__M9pJ1`,
	"visibleSm": `style_visible-sm__M9pJ1`,
	"hide-md": `style_hide-md__gTKV0`,
	"hideMd": `style_hide-md__gTKV0`,
	"visible-md": `style_visible-md__XFGaJ`,
	"visibleMd": `style_visible-md__XFGaJ`,
	"secondary": `style_secondary__PT3iD`,
	"section": `style_section__R4rkM`,
	"sectionHeader": `style_sectionHeader__pz9Vj`,
	"sectionBody": `style_sectionBody__MzPan`,
	"sectionNoHeader": `style_sectionNoHeader__s2duM`
};
module.exports = ___CSS_LOADER_EXPORT___;
